import React, { useState, useEffect } from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { auth, db } from './firebase';
import { onAuthStateChanged } from 'firebase/auth';
import { doc, getDoc } from 'firebase/firestore';
import Login from './Login';
import Profile from './Profile';
import Dashboard from './Dashboard';
import { getAccessToken } from './spotifyAuth';
import PrivacyPolicy from './PrivacyPolicy';
import TermsOfService from './TermsOfService';
import './App.css';

function MainApp() {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);
  const [hasProfile, setHasProfile] = useState(false);

  useEffect(() => {
    console.log('App.js mounted');
    console.log('Is native app?', window.isNativeApp);
    
    if (window.isNativeApp) {
      console.log('Running in native app - skipping web auth');
      const mockUser = {
        uid: 'flutter-user',
        email: 'flutter@app.com',
        displayName: 'Flutter User'
      };
      setUser(mockUser);
      setHasProfile(true);
      setLoading(false);
      return;
    }
    
    const unsubscribe = onAuthStateChanged(auth, async (currentUser) => {
      if (currentUser) {
        setUser(currentUser);
        
        const userDoc = await getDoc(doc(db, 'users', currentUser.uid));
        if (userDoc.exists() && userDoc.data().name) {
          setHasProfile(true);
        } else {
          setHasProfile(false);
        }
        
        const urlParams = new URLSearchParams(window.location.search);
        const code = urlParams.get('code');
        
        if (code) {
          console.log('App.js detected Spotify callback code');
          try {
            await getAccessToken(code);
            window.history.replaceState({}, document.title, window.location.pathname);
          } catch (error) {
            console.error('Error in App.js Spotify callback:', error);
          }
        }
      } else {
        setUser(null);
        setHasProfile(false);
      }
      setLoading(false);
    });

    return () => unsubscribe();
  }, []);

  if (loading) {
    return (
      <div style={{
        minHeight: '100vh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        backgroundColor: '#1a1a1a',
        fontFamily: 'Arial, sans-serif'
      }}>
        <div style={{ textAlign: 'center' }}>
          <h2 style={{ 
            color: '#DC143C',
            fontSize: '24px',
            marginBottom: '10px',
            fontWeight: '700'
          }}>
            Warrior Walkup Music
          </h2>
          <p style={{ 
            color: '#ffffff',
            fontSize: '14px',
            fontWeight: '600',
            letterSpacing: '0.5px'
          }}>
            AI Powered Beats for Warrior Players
          </p>
          <p style={{ color: '#999', marginTop: '15px' }}>Loading...</p>
        </div>
      </div>
    );
  }

  if (!user) {
    return <Login />;
  }

  if (!hasProfile) {
    return <Profile user={user} onProfileComplete={() => setHasProfile(true)} />;
  }

  return <Dashboard user={user} />;
}

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/privacy" element={<PrivacyPolicy />} />
        <Route path="/terms" element={<TermsOfService />} />
        <Route path="*" element={<MainApp />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;